<template>
  <div class="flex-1 overflow-auto p-4">
    <!-- List Canned Response -->
    <div class="flex flex-row gap-4">
      <div class="w-[60%]">
        <woot-loading-state v-if="isInitialLoading" />

        <p
          v-else-if="!inboxesList.length"
          class="flex h-full items-center flex-col justify-center"
        >
          {{ $t('INBOX_MGMT.LIST.404') }}
          <router-link
            v-if="isAdmin"
            :to="addAccountScoping('settings/inboxes/new')"
          >
            {{ $t('SETTINGS.INBOXES.NEW_INBOX') }}
          </router-link>
        </p>

        <table v-else-if="inboxesList.length" class="woot-table">
          <tbody>
            <tr v-for="item in inboxesList" :key="item.id">
              <td>
                <img
                  v-if="item.avatar_url"
                  class="woot-thumbnail"
                  :src="item.avatar_url"
                  alt="No Page Image"
                />
                <img
                  v-else
                  class="woot-thumbnail"
                  src="~dashboard/assets/images/flag.svg"
                  alt="No Page Image"
                />
              </td>
              <!-- Short Code  -->
              <td>
                <span class="agent-name w-60 overflow-hidden whitespace-nowrap text-ellipsis">{{ item.name }}</span>
                <span v-if="item.channel_type === 'Channel::FacebookPage'">
                  Facebook
                </span>
                <span v-if="item.channel_type === 'Channel::WebWidget'">
                  Website
                </span>
                <span v-if="item.channel_type === 'Channel::TwitterProfile'">
                  Twitter
                </span>
                <span v-if="item.channel_type === 'Channel::TwilioSms'">
                  {{ twilioChannelName(item) }}
                </span>
                <span v-if="item.channel_type === 'Channel::Whatsapp'">
                  Whatsapp
                </span>
                <span v-if="item.channel_type === 'Channel::Sms'"> Sms </span>
                <span v-if="item.channel_type === 'Channel::Email'">
                  Email
                </span>
                <span v-if="item.channel_type === 'Channel::Telegram'">
                  Telegram
                </span>
                <span v-if="item.channel_type === 'Channel::TwilioCall'">
                  Twilio Call
                </span>
                <span v-if="item.channel_type === 'Channel::JioEva'">
                  Jio EVA
                </span>
                <span v-if="item.channel_type === 'Channel::Smartflo'">
                  Tata Smartflo
                </span>
                <span v-if="item.channel_type === 'Channel::Indiamart'">
                  IndiaMART
                </span>
                <span v-if="item.channel_type === 'Channel::Line'">Line</span>
                <span v-if="item.channel_type === 'Channel::Api'">
                  {{ globalConfig.apiChannelName || 'API' }}
                </span>
              </td>

              <!-- Action Buttons -->
              <td>
                <div class="button-wrapper">
                  <router-link
                    :to="addAccountScoping(`settings/inboxes/${item.id}`)"
                  >
                    <woot-button
                      v-if="isAdmin"
                      v-tooltip.top="$t('INBOX_MGMT.SETTINGS')"
                      variant="smooth"
                      size="tiny"
                      icon="settings"
                      viewBox="0 0 34 30"
                      color-scheme="secondary"
                      class-names="grey-btn"
                    />
                  </router-link>

                  <woot-button
                    v-if="isAdmin"
                    v-tooltip.top="$t('INBOX_MGMT.DELETE.BUTTON_TEXT')"
                    variant="smooth"
                    color-scheme="alert"
                    size="tiny"
                    class-names="grey-btn"
                    :is-loading="loading[item.id]"
                    icon="dismiss-circle"
                    @click="openDelete(item)"
                  />
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <div class="w-[34%]">
        <span
          v-dompurify-html="
            useInstallationName(
              $t('INBOX_MGMT.SIDEBAR_TXT'),
              globalConfig.installationName
            )
          "
        />
      </div>
    </div>
    <settings
      v-if="showSettings"
      :show.sync="showSettings"
      :on-close="closeSettings"
      :inbox="selectedInbox"
    />

    <woot-confirm-delete-modal
      v-if="showDeletePopup"
      :show.sync="showDeletePopup"
      :title="$t('INBOX_MGMT.DELETE.CONFIRM.TITLE')"
      :message="confirmDeleteMessage"
      :sub-message="$t('INBOX_MGMT.DELETE.CONFIRM.CONVERSATIONS_WARNING')"
      :confirm-text="deleteConfirmText"
      :reject-text="deleteRejectText"
      :confirm-value="selectedInbox.name"
      :confirm-place-holder-text="confirmPlaceHolderText"
      @on-confirm="confirmDeletion"
      @on-close="closeDelete"
    />
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
import Settings from './Settings';
import adminMixin from '../../../../mixins/isAdmin';
import accountMixin from '../../../../mixins/account';
import globalConfigMixin from 'shared/mixins/globalConfigMixin';

export default {
  components: {
    Settings,
  },
  mixins: [adminMixin, accountMixin, globalConfigMixin],
  data() {
    return {
      loading: {},
      showSettings: false,
      showDeletePopup: false,
      selectedInbox: {},
      haveConversations: false,
      isInitialLoading: true,
    };
  },
  computed: {
    ...mapGetters({
      inboxesList: 'inboxes/getInboxes',
      globalConfig: 'globalConfig/get',
    }),
    // Delete Modal
    deleteConfirmText() {
      return `${this.$t('INBOX_MGMT.DELETE.CONFIRM.YES')} ${
        this.selectedInbox.name
      }`;
    },
    deleteRejectText() {
      return `${this.$t('INBOX_MGMT.DELETE.CONFIRM.NO')} ${
        this.selectedInbox.name
      }`;
    },
    confirmDeleteMessage() {
      return `${this.$t('INBOX_MGMT.DELETE.CONFIRM.MESSAGE')} ${
        this.selectedInbox.name
      }?`;
    },
    confirmPlaceHolderText() {
      return `${this.$t('INBOX_MGMT.DELETE.CONFIRM.PLACE_HOLDER', {
        inboxName: this.selectedInbox.name,
      })}`;
    },
  },
  methods: {
    twilioChannelName(item) {
      const { medium = '' } = item;
      if (medium === 'whatsapp') return 'WhatsApp';
      return 'Twilio SMS';
    },
    openSettings(inbox) {
      this.showSettings = true;
      this.selectedInbox = inbox;
    },
    closeSettings() {
      this.showSettings = false;
      this.selectedInbox = {};
    },
    async deleteInbox({ id }) {
      try {
        await this.$store.dispatch('inboxes/delete', id);
        bus.$emit(
          'newToastMessage',
          this.$t('INBOX_MGMT.DELETE.API.SUCCESS_MESSAGE')
        );
      } catch (error) {
        bus.$emit(
          'newToastMessage',
          this.$t('INBOX_MGMT.DELETE.API.ERROR_MESSAGE')
        );
      }
    },

      conversationFilters() {
      return {
        inboxId: this.selectedInbox ? this.selectedInbox.id : undefined,
        assigneeType: "all",
        status: "open",
        sortBy: "latest",
        page: 1,
      };
    },

   async  fetchConversations() {
    console.log("get called ")
     const result =  await this.$store
        .dispatch('fetchConversationsForInboxes', this.conversationFilters())

        if(result?.payload.length){
          this.haveConversations = true
        }else{
          this.haveConversations = false
        }

    },

    confirmDeletion() {
      let confirm= true 

      if(this.haveConversations){
        confirm = window.confirm("There are related Conversation to this Inbox")
      }

      if(confirm){
        this.deleteInbox(this.selectedInbox);
      }

      this.closeDelete();
    },
    openDelete(inbox) {
      this.showDeletePopup = true;
      this.selectedInbox = inbox;
      this.fetchConversations()
    },
    closeDelete() {
      this.showDeletePopup = false;
      this.selectedInbox = {};
    },
    showMicrosoftOauthToastFromQuery() {
      const q = this.$route.query || {};
      if (q.microsoft_oauth_mailbox_in_use === '1' && q.blocking_account_id) {
        bus.$emit(
          'newToastMessage',
          this.$t('INBOX_MGMT.MICROSOFT_OAUTH.MAILBOX_IN_USE', {
            accountId: q.blocking_account_id,
          })
        );
      } else if (q.microsoft_oauth_error === 'generic') {
        bus.$emit(
          'newToastMessage',
          this.$t('INBOX_MGMT.MICROSOFT_OAUTH.GENERIC_ERROR')
        );
      }

      if (q.microsoft_oauth_mailbox_in_use || q.microsoft_oauth_error) {
        this.$router.replace({ path: this.$route.path, query: {} });
      }
    },
  },
  mounted() {
    this.showMicrosoftOauthToastFromQuery();
    if (this.inboxesList.length) {
      this.isInitialLoading = false;
      return;
    }
    this.$store.dispatch('inboxes/get').finally(() => {
      this.isInitialLoading = false;
    });
  },
};
</script>
